import { Box } from "@mui/material";
import DoDisturbAltIcon from "@mui/icons-material/DoDisturbAlt";
import { useTranslation } from "react-i18next";

const ProjectTableDenyPresentes = (props) => {
  const { sxWrapper, sxContent } = props;
  const { t } = useTranslation();
  return (
    <Box
      sx={{
        widht: "100%",
        height: "70vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        ...sxWrapper,
      }}
    >
      <Box
        sx={{
          maxWidth: "500px",
          width: "40%",
          background: "white",
          height: "400px",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          flexDirection: "column",
          border: "1px solid #ebebeb",
          borderRadius: "10px",
          "& p": {
            width: "70%",
            textAlign: "center",
          },
          "& svg": {
            width: "62px",
            height: "62px",
          },
          "& p:nth-child(2)": {
            color: "#111111",
            fontSize: "1.5rem",
            fontWeight: "bold",
            lineHeight: "1.5",
            marginBottom: "10px",
          },
          "& p:nth-child(3)": {
            color: "#B0B0B0",
            marginTop: "0px",
            fontSize: "14px",
            lineHeight: "1.5",
            fontWeight: "normal",
          },
          ...sxContent,
        }}
      >
        {props.icon ? (
          props.icon
        ) : (
          <DoDisturbAltIcon sx={{ color: "#9A9A9A" }} />
        )}
        <p>
          {props.title ? props.title : t("PROJECT_TABLE_DENY.DEFAULT.TITLE")}
        </p>
        <p>
          {props.description
            ? props.description
            : t("PROJECT_TABLE_DENY.DEFAULT.DES")}
        </p>
        {props.action}
      </Box>
    </Box>
  );
};

export default ProjectTableDenyPresentes;
